<template lang="pug">
  div
    div(v-if="firstValue")
      span(
        v-if="firstValuePrependText"
        class="text-10px fw-300 dark"
      ) {{ firstValuePrependText }}
      span {{ firstValue }}
    div(v-if="secondValue")
      span(
        v-if="secondValuePrependText"
        class="text-10px fw-300 dark"
      ) {{ secondValuePrependText }}
      span {{ secondValue }}
</template>

<script>
export default {
  name: 'EOrganizationNameEmailText',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    firstValuePath: {
      type: String,
      default: null
    },
    secondValuePath: {
      type: String,
      default: null
    },
    firstValuePrependText: {
      type: String,
      default: null
    },
    secondValuePrependText: {
      type: String,
      default: null
    }
  },
  computed: {
    firstValue() {
      return this._.get(this.item, this.firstValuePath, null)
    },
    secondValue() {
      return this._.get(this.item, this.secondValuePath, null)
    }
  }
}
</script>

<style scoped lang="scss"></style>
